import { render, staticRenderFns } from "./return_journey.vue?vue&type=template&id=3fdd4612&scoped=true&"
import script from "./return_journey.vue?vue&type=script&lang=js&"
export * from "./return_journey.vue?vue&type=script&lang=js&"
import style0 from "./return_journey.vue?vue&type=style&index=0&id=3fdd4612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd4612",
  null
  
)

export default component.exports